import React, { Component, Fragment } from "react";
import ReactCSSTransitionGroup from "react-addons-css-transition-group";

import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Creators as AuthActions } from "store/ducks/auth";

import { withTranslation } from "react-i18next";
import { compose } from "recompose";

import Logo from "assets/images/logo.svg";
import Mountain from "assets/images/mountain.png";

const mapState = state => ({
  user: state.auth.user
});

const mapActions = dispatch => bindActionCreators(AuthActions, dispatch);

export default Page =>
  compose(
    connect(mapState, mapActions),
    withTranslation()
  )(
    class extends Component {
      state = {
        visible: false,
        face: "south"
      };

      componentDidMount() {
        const { location, getAuthUserRequest } = this.props;
        const { pathname } = location;

        const face = this.getFace(pathname);

        getAuthUserRequest();

        this.setState({ visible: true, face });
      }

      componentDidUpdate(oldProps) {
        const { location } = this.props;

        if (oldProps.location.pathname !== location.pathname) {
          this.setState({
            visible: true,
            face: this.getFace(location.pathname)
          });
        }
      }

      getFace = pathname => {
        return pathname.includes("south")
          ? "south"
          : pathname.includes("east")
          ? "east"
          : pathname.includes("north")
          ? "north"
          : pathname.includes("west")
          ? "west"
          : "complete";
      };

      render() {
        const { face, visible } = this.state;
        const { user, t } = this.props;

        return (
          <ReactCSSTransitionGroup
            transitionName="fade"
            transitionEnterTimeout={500}
            transitionLeaveTimeout={300}
          >
            {visible && (
              <Fragment>
                <div className="wrapper" id="journey">
                  <div className="container-fluid">
                    <img src={Logo} className="logo" alt="" />
                    <Page {...this.props} />
                  </div>

                  {face !== "complete" && (
                    <div className="footer">
                      <div className="container-fluid">
                        <div className="user">
                          <span className="user-name">
                            {user.data.id && user.data.attributes.name}
                          </span>
                          <span className="user-email">
                            {user.data.id && user.data.attributes.email}
                          </span>
                        </div>

                        <div className="face">
                          <img src={Mountain} alt="" />

                          <span>
                            {face === "south"
                              ? t("Face Sul")
                              : face === "east"
                              ? t("Face Leste")
                              : face === "north"
                              ? t("Face Norte")
                              : t("Face Oeste")}
                          </span>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </Fragment>
            )}
          </ReactCSSTransitionGroup>
        );
      }
    }
  );



// WEBPACK FOOTER //
// ./src/layouts/Journey/index.js